import React, { Component } from "react";
import { optionMasterService } from "app/_services/OptionMasterService/optionMasterService";
import toastr from "toastr";
import { Link } from "react-router-dom";
import { ProjectService } from "app/_services/ProjectService/ProjectService";
import {
  Dropdown,
  Row,
  Col,
  Tab,
  Tabs,
  Button,
  TabContent,
  Nav,
  OverlayTrigger,
  Tooltip,
  Image,
} from "react-bootstrap";
import { BsFileEarmarkArrowUp } from "react-icons/bs";
import { FiPlusCircle, FiMinusCircle, FiCopy } from "react-icons/fi";
import DateTime from "react-datetime";
import { globalSettings } from "app/_services/GlobalSettings/globalSettingsServices";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import Loader from "app/views/custom/components/Loader/Loader.jsx";
class ManageCompanySettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      settings: [
        {
          metaKey: "Enter user count",
          metaValue: "",
          inputType: 5,
          documentId: "",
        },
        {
          metaKey: "Footer Description",
          metaValue: "",
          inputType: 2,
          documentId: "",
        },
        {
          metaKey: "Footer Link",
          metaValue: "",
          inputType: 2,
          documentId: "",
        },
        {
          metaKey: "Footer Logo",
          metaValue: "",
          inputType: 1,
          documentId: "",
        },
        {
          metaKey: "IED Logo",
          metaValue: "",
          inputType: 1,
          documentId: "",
        },
        {
          metaKey: "Client Logo",
          metaValue: "",
          inputType: 1,
          documentId: "",
        },
      ],
      src: "",
    };
    this.getAllGlobalSettings = this.getAllGlobalSettings.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleFileSelect = this.handleFileSelect.bind(this);
  }

  componentDidMount() {
    this.getAllGlobalSettings();
  }

  async getAllGlobalSettings() {
    let response = await globalSettings.globalAllSettings();
    if (response && response.data && response.data.global_settings) {
      this.setState({
        settings: response.data.global_settings,
      });
    }
  }

  onChange(e, index) {
    let response = this.state.settings.slice();
    let value = e.target.value;
    if (value.length < 101) {
      Array.isArray(response) &&
        response.length !== 0 &&
        response.map((data, index_1) => {
          if (index === index_1) {
            response[index].metaValue = e.target.value;
          }
        });
      this.setState({
        settings: response,
      });
    } else {
      toastr.warning("Max Limit 100");
    }
  }

  async update() {
    let response = await globalSettings.updateGlobalSetting({
      globalSettings: this.state.settings,
    });
    if (response && response.status === 1) {
      toastr.info(response.status_message);
      this.getAllGlobalSettings();
    }
  }

  handleFileSelect = (event, index) => {
    let file = event.target.files[0];
    if (file) {
      let src = URL.createObjectURL(file);
      this.setState(
        {
          src,
          showImage: true,
          cropImage: true,
          isLoading: true,
        },
        async () => {
          let document_id = "";
          let name = "";
          let formData = "";
          if (this.state.src) {
            formData = new FormData();
            let blob = await fetch(this.state.src).then((r) => r.blob());
            formData.append("file", blob);
            let fileUploadResponse = await CommmonService.uploadDocument(formData);
            if (
              fileUploadResponse &&
              fileUploadResponse.status &&
              fileUploadResponse.data
            ) {
              document_id = fileUploadResponse.data.id;
              name = fileUploadResponse.data.real_document_name;
            }
          }

          let response = this.state.settings.slice();
          Array.isArray(response) &&
            response.length !== 0 &&
            response.map((data, index_1) => {
              if (index === index_1) {
                response[index].metaValue = document_id;
                response[index].documentId = document_id;
                response[index].src = this.state.src;
                response[index].name = name;
              }
            });
          this.setState({
            settings: response,
            isLoading: false,
          });
        }
      );
    } else {
      this.setState({
        src: "",
        showImage: false,
        cropImage: false,
      });
    }
  };

  render() {
    console.log("this", this.state);
    const {
      section,
      module,
      Submodule,
      Priority,
      IssueSummary,
      IssueDescription,
      Attachments,
      isLoading,
    } = this.state;
    return (
      <div>
        {/* <Breadcrumb
                    routeSegments={[
                        // { name: this.state.projectData.name, path: "/project/" + this.state.projectId + "/dashboard" },
                        { name: "Manage Company Settings" }
                    ]}
                /> */}
        <MainBreadcrumb
          routeSegments={[{ name: "Manage Company Settings", path: "#" }]}
          breadCrumbsText="Manage_Company_Setting"
        />
        <Loader loading={isLoading}></Loader>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <h4>Manage Company Settings</h4>
                <div className="manageCompanyTab-bar">
                  <Tab.Container id="left-tabs-example" defaultActiveKey="1">
                    <Row>
                      <Col sm={12} md={12} lg={12}>
                        <Nav variant="pills" className="DrillingPlanDetailsTab">
                          {Array.isArray(this.state.settings) &&
                            this.state.settings.map((data, index) => {
                              return (
                                <Nav.Item className="mr-5">
                                  <Nav.Link eventKey={index + 1}>{data.metaKey}</Nav.Link>
                                </Nav.Item>
                              );
                            })}
                          {/* <Nav.Item className="mr-5">
                                                        <Nav.Link eventKey="1">Change Logo</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item className="mr-5">
                                                        <Nav.Link eventKey="2">Change Footer Text</Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item className="mr-5">
                                                        <Nav.Link eventKey="3">Change Banner</Nav.Link>
                                                    </Nav.Item> */}
                        </Nav>
                      </Col>
                      <Col sm={12} md={12} lg={12} className="d-flex align-items-center">
                        <Tab.Content className="w-100 p-0">
                          {Array.isArray(this.state.settings) &&
                            this.state.settings.map((data, index) => {
                              return (
                                <Tab.Pane eventKey={index + 1}>
                                  <div>
                                    {parseInt(data.inputType) === 1 ? (
                                      <React.Fragment>
                                        <label>{data.metaKey}</label>
                                        <div className="uploadFileBtn mr-3">
                                          <label htmlFor="upload-single-file">
                                            <BsFileEarmarkArrowUp
                                              size="30"
                                              color="#00b5ef"
                                            />
                                          </label>
                                          <input
                                            className="uploadFile"
                                            onChange={(e) =>
                                              this.handleFileSelect(e, index)
                                            }
                                            id="upload-single-file"
                                            type="file"
                                            accept="image/*"
                                          ></input>
                                        </div>
                                        {data.src ? (
                                          <Image
                                            style={{ width: "100px", height: "75px" }}
                                            src={data.src}
                                          ></Image>
                                        ) : (
                                          <React.Fragment>
                                            {data &&
                                              data.document &&
                                              data.document.document_name && (
                                                <Image
                                                  style={{
                                                    width: "100px",
                                                    height: "75px",
                                                  }}
                                                  src={
                                                    URL_CONFIG.IMG_URL +
                                                    data.document.document_name
                                                  }
                                                ></Image>
                                              )}
                                          </React.Fragment>
                                        )}
                                      </React.Fragment>
                                    ) : parseInt(data.inputType) === 2 ? (
                                      <React.Fragment>
                                        <div className="form-group mb-3">
                                          <label>{data.metaKey}</label>
                                          <textarea
                                            name="description"
                                            placeholder="Enter Data"
                                            className="form-control"
                                            rows="3"
                                            value={data.metaValue}
                                            onChange={(e) => this.onChange(e, index)}
                                            style={{ minHeight: 84 }}
                                          ></textarea>
                                        </div>
                                      </React.Fragment>
                                    ) : parseInt(data.inputType) === 5 ? (
                                      <React.Fragment>
                                        <div className="form-group mb-3">
                                          <label>{data.metaKey}</label>
                                          <input
                                            name="description"
                                            placeholder="Enter Data"
                                            className="form-control"
                                            type="tel"
                                            onKeyPress={(event) => {
                                              if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                              }
                                            }}
                                            value={data.metaValue}
                                            onChange={(e) => this.onChange(e, index)}
                                          />
                                        </div>
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        <label>{data.metaKey}</label>
                                        <div className="uploadFileBtn mr-3">
                                          <label htmlFor="upload-single-file">
                                            <BsFileEarmarkArrowUp
                                              size="30"
                                              color="#00b5ef"
                                            />
                                          </label>
                                          <input
                                            className="uploadFile"
                                            onChange={(e) =>
                                              this.handleFileSelect(e, index)
                                            }
                                            id="upload-single-file"
                                            type="file"
                                            accept="*"
                                          ></input>
                                        </div>
                                        {data &&
                                          data.document &&
                                          data.document.document_name && (
                                            <a
                                              href={
                                                URL_CONFIG.IMG_URL +
                                                data.document.document_name
                                              }
                                              target="_blank"
                                            >
                                              {data.name
                                                ? data.name
                                                : data.document.real_document_name
                                                ? data.document.real_document_name
                                                : "PDF"}
                                            </a>
                                          )}
                                      </React.Fragment>
                                    )}
                                  </div>
                                </Tab.Pane>
                              );
                            })}
                          {/* <Tab.Pane eventKey="2">
                                                        <div className="form-group mb-3">
                                                            <label>Footer Description</label>
                                                            <textarea
                                                                name="description"
                                                                placeholder="Enter Project Description"
                                                                className="form-control"
                                                                rows="3"
                                                                style={{ minHeight: 84 }}
                                                            >© Copyright 2020 iEnergy - All Rights Reserved.</textarea>
                                                        </div>
                                                    </Tab.Pane> */}
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>
                  <div className="text-center mt-3">
                    <Button
                      type="submit"
                      variant="primary"
                      className="m-1 text-capitalize"
                      onClick={() => this.update()}
                    >
                      Update Settings
                    </Button>
                  </div>
                </div>

                <p className="text-center mb-0 mt-3">
                  <b style={{ fontSize: "18px" }}>*</b> Changes will be reflected when you
                  login again
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ManageCompanySettings;
